<script setup lang="ts">
import { ref, watch } from 'vue'
import { VSearchableMultiSelect } from '@/modules/shared/components'

const props = defineProps<{
  modelValue: {
    university_affiliations: string[]
  }
  universities: string[]
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: typeof props.modelValue): void
}>()

const affiliations = ref<string[]>([...props.modelValue.university_affiliations])

watch(
  () => props.modelValue,
  (val) => {
    const incoming = val.university_affiliations
    const same = affiliations.value.length === incoming.length && affiliations.value.every((u, i) => u === incoming[i])
    if (!same) affiliations.value = [...incoming]
  },
  { deep: true },
)

const emitUpdate = () => {
  emit('update:modelValue', {
    university_affiliations: [...affiliations.value],
  })
}

watch(affiliations, emitUpdate, { deep: true })

const isValid = async () => true

defineExpose({ isValid })
</script>

<template>
  <VSearchableMultiSelect
    v-model="affiliations"
    :options="universities"
    placeholder="Search for your university..."
    empty-message="No universities found"
  />
</template>
